import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { linkedCompanyRegExp, linkedInRegExp, urlRegExp } from '@core/models/pattern';

@Component({
  selector: 'app-feild-error',
  templateUrl: './feild-error.component.html',
  styleUrls: ['./feild-error.component.css']
})
export class FeildErrorComponent implements OnInit {
  /* formControl */
  urlRegExp=urlRegExp
  linkedCompanyRegExp=linkedCompanyRegExp
  linkedInRegExp=linkedInRegExp
  _control: AbstractControl | null = new FormControl();
  /* Input */
  @Input() set control(value: AbstractControl | null | undefined) {
    if (value) {
      this._control = value;
    }
  }
  @Input() controlName!:string
ngOnInit(): void {
}
}
